(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/game-engine/assets/javascripts/engines/base/result.js') >= 0) return;  svs.modules.push('/components/racing/game-engine/assets/javascripts/engines/base/result.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const couponValues = svs.racing.common.constants.couponValues;
const getDrawOfGameType = svs.racing.common.util.getDrawOfGameType;
const SYSTEM_TYPE = svs.racing.common.constants.systemTypes.RESULT;
function createEngine(options) {
  const getInitialState = config => {
    if (!config || !config.race || !config.race.participants) {
      throw new Error("Can't initialize engine without a config or race");
    }
    const draw = getDrawOfGameType(config.race, options.gameType);
    return {
      error: undefined,
      meta: {
        raceId: config.race.raceId,
        drawNumber: draw ? draw.drawNumber : 0
      },
      row: config.race.participants.map(participant => {
        if (participant.canceled) {
          return couponValues.CANCELED;
        }
        if (participant.participantResult && participant.participantResult.finishPlace && participant.participantResult.finishPlace > 0) {
          return participant.participantResult.finishPlace;
        }
        return undefined;
      }),
      rowStatus: config.race.participants.map(participant => {
        if (participant.participantResult && participant.participantResult.finishPlaceReason) {
          return participant.participantResult.finishPlaceReason;
        }
        return undefined;
      })
    };
  };
  const selectors = {
    getRow(state) {
      return state.row.map(value => value);
    },
    getIndexAsObject(state, index) {
      return {
        place: state.row[index],
        status: state.rowStatus[index]
      };
    }
  };
  const actions = {
    initialize(race) {
      return {
        type: 'INITIALIZE',
        race
      };
    }
  };
  const reducer = (state, action) => {
    switch (action.type) {
      case 'INITIALIZE':
        {
          return getInitialState({
            race: action.race
          });
        }
      default:
        return state;
    }
  };
  return _objectSpread(_objectSpread({}, options), {}, {
    systemType: SYSTEM_TYPE,
    getInitialState,
    selectors,
    actions,
    reducer
  });
}

svs.racing.gameEngine.engines.result = createEngine({
  stake: {
    amounts: [0]
  },
  amountsDefaultIndex: 0
});

 })(window);